module.exports = __webpack_public_path__ + "img/009.b4dbc5dd.png";